import { defineComponent as n, createBlock as l, openBlock as r, unref as a, mergeProps as p, withCtx as c, createElementVNode as i } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const u = /* @__PURE__ */ n({
  name: "IconBoltFilled",
  __name: "IconBoltFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (s, e) => (r(), l(a(m), p(o, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        i("path", { d: "M14.247 3.47c.278-1.323-1.449-2.085-2.238-.988L4.962 12.27a1.25 1.25 0 0 0 1.014 1.98h5.1l-1.323 6.28c-.278 1.323 1.448 2.085 2.238.988l7.047-9.788a1.25 1.25 0 0 0-1.014-1.98h-5.1l1.322-6.28" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
